import { State } from '@meraki-internal/state';
import { ICaremapNoteResponse } from '../model/NotesClient';
import { CaremapNotesModelFactory } from '../model/CaremapNotesModelFactory';
import { IFreeTierLimits } from '../../innerhive-plus/revenue-cat/IFreeTierLimits';

export class EditNoteFormViewModel extends State<Record<string, never>> {
    constructor(private note: ICaremapNoteResponse, private factory: CaremapNotesModelFactory){
        super({ });
    }

    isValid = () => this.factory.validator.isValid(this.getNote());

    getNote = () => {
        return this.note;
    };

    setNote = (note: ICaremapNoteResponse) => {
        // TODO: we're assuming we're dirty, better would be to diff
        this.isDirty = true;

        this.note = note;
        this.setState({ });
    };

    canSave = () => {
        return !this.isSaving && this.isValid() && this.isDirty;
    };

    isDirty = false;
    isSaving = false;

    save = async ({
        trackingEvent,
        trackingFrom,
        skipTracking
    }: {
        trackingEvent?: string;
        trackingFrom?: string;
        skipTracking?: boolean;
    } = {}) => {
        this.isSaving = true;
        this.setState({ });

        try {
            await this.factory.forActiveCaremap().putNote(this.getNote());

            if (!skipTracking) {
                this.trackSaved(trackingEvent, trackingFrom);
            }
        }
        finally {
            this.isSaving = false;
            this.setState({ });
        }

    };

    private trackSaved = (trackingEvent?: string, trackingFrom?: string,) => {
        this.factory.tracking.onUpdatedNote(this.getNote(), trackingEvent, trackingFrom);
    };

    addAttachmentRequiresInnerhivePlus = (limits: IFreeTierLimits) => {
        return this.factory.attachmentCountHelper.addAttachmentRequiresInnerhivePlus(limits, this.getNote());
    };

    // if not, then read only
    canEdit = () => {
        return this.note.links.self && (this.note.links.self.actions || []).includes('put-note');
    };

    canDelete = () => {
        return this.note.links.self && (this.note.links.self.actions || []).includes('delete-note');
    };

    delete = async (trackingFrom?: string) => {
        await this.factory.forActiveCaremap().deleteNote(this.getNote());
        this.factory.tracking.onDeletedNote(this.getNote(), trackingFrom);
    };
}
